type BuildElevioArticleLinkArgs = {
  baseUrl: string | undefined;
  slug: string;
  id: string;
  languageId: string;
};
export function buildElevioArticleLink({
  languageId,
  baseUrl,
  slug,
  id,
}: BuildElevioArticleLinkArgs): string | null {
  if (!baseUrl) return null;
  const base = baseUrl.startsWith('http') ? baseUrl : `https://${baseUrl}`;
  return `${base}/${languageId}/articles/${id}-${slug}/`;
}
